export default {
  init: function init() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var self = this;
    self.isBot = false;
    self.tests = {};
    self.Tests = {
      KEYUP: 'keyup',
      //键盘事件
      MOUSE: 'mousemove',
      //鼠标事件
      SWIPE: 'swipe',
      //移动端 滑屏事件
      SWIPE_TOUCHSTART: 'touchstart',
      SWIPE_TOUCHMOVE: 'touchmove',
      SWIPE_TOUCHEND: 'touchend',
      SCROLL: 'scroll',
      WHEEL: 'wheel',
      GESTURE: 'gesture',
      GYROSCOPE: 'gyroscope',
      DEVICE_MOTION: 'devicemotion',
      DEVICE_ORIENTATION: 'deviceorientation',
      DEVICE_ORIENTATION_MOZ: 'MozOrientation',
      ORIENTATION_CHANGE: 'orientationchange'
    };
    var selectedTests = args.tests || [];

    if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.WHEEL) != -1) {
      self.tests[self.Tests.WHEEL] = function () {
        var e = function e(event) {
          self.tests[self.Tests.WHEEL] = true;
          self.update();
          self.unbindEvent(window, self.Tests.WHEEL, e);
          self.unbindEvent(document, self.Tests.WHEEL, e);
        };

        self.bindEvent(window, self.Tests.WHEEL, e);
        self.bindEvent(document, self.Tests.WHEEL, e);
      };
    }

    if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.SCROLL) != -1) {
      self.tests[self.Tests.SCROLL] = function () {
        var e = function e() {
          self.tests[self.Tests.SCROLL] = true;
          self.update();
          self.unbindEvent(window, self.Tests.SCROLL, e);
          self.unbindEvent(document, self.Tests.SCROLL, e);
        };

        self.bindEvent(window, self.Tests.SCROLL, e);
        self.bindEvent(document, self.Tests.SCROLL, e);
      };
    }

    if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.MOUSE) != -1) {
      self.tests[self.Tests.MOUSE] = function () {
        var e = function e() {
          self.tests[self.Tests.MOUSE] = true;
          self.update();
          self.unbindEvent(window, self.Tests.MOUSE, e);
        };

        self.bindEvent(window, self.Tests.MOUSE, e);
      };
    }

    if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.KEYUP) != -1) {
      self.tests[self.Tests.KEYUP] = function () {
        var e = function e() {
          self.tests[self.Tests.KEYUP] = true;
          self.update();
          self.unbindEvent(window, self.Tests.KEYUP, e);
        };

        self.bindEvent(window, self.Tests.KEYUP, e);
      };
    }

    if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.SWIPE) != -1) {
      self.tests[self.Tests.SWIPE_TOUCHSTART] = function () {
        var e = function e() {
          self.tests[self.Tests.SWIPE_TOUCHSTART] = true;
          self.update();
          self.unbindEvent(document, self.Tests.SWIPE_TOUCHSTART);
        };

        self.bindEvent(document, self.Tests.SWIPE_TOUCHSTART, e);
      };
    }

    if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.DEVICE_MOTION) != -1) {
      self.tests[self.Tests.DEVICE_MOTION] = function () {
        var e = function e(event) {
          if (event.rotationRate.alpha || event.rotationRate.beta || event.rotationRate.gamma) {
            var userAgent = navigator.userAgent.toLowerCase();
            var isAndroid = userAgent.indexOf('android') != -1;
            var beta = isAndroid ? event.rotationRate.beta : Math.round(event.rotationRate.beta / 10) * 10;
            var gamma = isAndroid ? event.rotationRate.gamma : Math.round(event.rotationRate.gamma / 10) * 10;

            if (!self.lastRotationData) {
              self.lastRotationData = {
                beta: beta,
                gamma: gamma
              };
            } else {
              var movement = beta != self.lastRotationData.beta || gamma != self.lastRotationData.gamma;

              if (isAndroid) {
                movement = movement && (beta > 0.2 || gamma > 0.2);
              }

              var _args = {
                beta: beta,
                gamma: gamma
              }; // self.tests[self.Tests.DEVICE_MOTION] = movement;
              // self.update();

              if (movement) {
                self.tests[self.Tests.DEVICE_MOTION] = movement;
                self.update();
                self.unbindEvent(window, self.Tests.DEVICE_MOTION, e);
              }
            }
          } else {
            self.tests[self.Tests.DEVICE_MOTION] = false;
          }
        };

        self.bindEvent(window, self.Tests.DEVICE_MOTION, e);
      };
    }

    if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.DEVICE_ORIENTATION) != -1) {
      self.tests[self.Tests.DEVICE_ORIENTATION] = function () {
        var e = function e(event) {
          var userAgent = navigator.userAgent.toLowerCase();
          var isFirefox = userAgent.indexOf('firefox') != -1;

          if ((event.alpha || event.beta || event.gamma) && !isFirefox) {
            var alpha = event.alpha;
            var beta = event.beta;
            var gamma = event.gamma;

            if (!self.lastOrienData) {
              self.lastOrienData = {
                alpha: alpha,
                beta: beta,
                gamma: gamma
              };
              self.lastOrienDataCount = 0;
            } else {
              self.lastOrienDataCount++;
              var movement = alpha != self.lastOrienData.alpha || beta != self.lastOrienData.beta || gamma != self.lastOrienData.gamma;
              self.lastOrienData = {
                alpha: alpha,
                beta: beta,
                gamma: gamma
              };

              if (movement && self.lastOrienDataCount > 3) {
                self.tests[self.Tests.DEVICE_ORIENTATION] = true;
                self.update();
                self.unbindEvent(window, self.Tests.DEVICE_ORIENTATION, e);
              }
            }
          } else {
            self.tests[self.Tests.DEVICE_ORIENTATION] = false;
            self.unbindEvent(window, self.Tests.DEVICE_ORIENTATION, e);
          }
        };

        self.bindEvent(window, self.Tests.DEVICE_ORIENTATION, e);
      };
    } // if (selectedTests.length == 0 || selectedTests.indexOf(self.Tests.DEVICE_ORIENTATION_MOZ) != -1) {
    //   self.tests[self.Tests.DEVICE_ORIENTATION_MOZ] = function() {
    //     let e = function(event) {
    //       if(event.x || event.y || event.z) {
    //         let x = event.x;
    //         let y = event.y;
    //         let z = event.z;
    //         if (!self.lastOrienMozData) {
    //           self.lastOrienMozData = {
    //             x: x,
    //             y: y,
    //             z: z
    //           };
    //         }
    //         else {
    //           let movement = x != self.lastOrienMozData.x || y != self.lastOrienMozData.y || z != self.lastOrienMozData.z;
    //           self.lastOrienMozData = { x: x, y: y, z: z }
    //           if (movement) {
    //             self.tests[self.Tests.DEVICE_ORIENTATION_MOZ] = true;
    //             self.update();
    //             self.unbindEvent(window, self.Tests.DEVICE_ORIENTATION_MOZ, e);
    //           }
    //         }
    //       }
    //     }
    //     self.bindEvent(window, self.Tests.DEVICE_ORIENTATION_MOZ, e);
    //   }
    // }


    self.cases = {};
    self.timeout = args.timeout || 1000;
    self.callback = args.callback || null;
    self.detected = false;
    self.monitor();
  },
  monitor: function monitor() {
    var self = this;

    for (var i in this.tests) {
      if (this.tests.hasOwnProperty(i)) {
        this.tests[i].call();
      }
    }

    self.update(false);
    setTimeout(function () {
      self.update(true);
    }, self.timeout);
  },
  bindEvent: function bindEvent(e, type, handler) {
    if (e.addEventListener) {
      e.addEventListener(type, handler, false);
    } else if (e.attachEvent) {
      e.attachEvent('on' + type, handler);
    }
  },
  update: function update(notify) {
    var self = this;
    var count = 0;
    var tests = 0;

    for (var i in self.tests) {
      if (self.tests.hasOwnProperty(i)) {
        self.cases[i] = self.tests[i] === true;

        if (self.cases[i] === true) {
          count++;
        }
      }

      tests++;
    }

    self.isBot = count == 0;
    self.allMatched = count == tests;

    if (notify !== false) {
      self.callback({
        isBot: self.isBot,
        allMatched: self.allMatched,
        tests: self.tests
      });
    }
  },
  unbindEvent: function unbindEvent(e, type, handle) {
    if (e.removeEventListener) {
      e.removeEventListener(type, handle, false);
    } else {
      var evtName = 'on' + type;

      if (e.detachEvent) {
        if (typeof e[evtName] === 'undefined') {
          e[type] = null;
        }

        e.detachEvent(evtName);
      }
    }
  }
};